var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0658 4.16535C20.7444 3.89278 20.2395 3.85378 19.7175 4.06335H19.7167C19.1677 4.28364 4.17619 10.7139 3.5659 10.9767C3.4549 11.0152 2.48547 11.3769 2.58533 12.1827C2.67447 12.9091 3.45362 13.2099 3.54876 13.2447L7.36006 14.5497C7.61292 15.3914 8.54506 18.4968 8.7512 19.1603C8.87978 19.5738 9.08935 20.1173 9.45664 20.2291C9.77892 20.3534 10.0995 20.2398 10.3069 20.077L12.6371 17.9157L16.3987 20.8493L16.4882 20.9028C16.7437 21.016 16.9884 21.0725 17.2219 21.0725C17.4024 21.0725 17.5755 21.0387 17.7409 20.971C18.3045 20.7395 18.53 20.2025 18.5535 20.1417L21.3632 5.53721C21.5347 4.75721 21.2964 4.36035 21.0658 4.16535ZM10.7214 15.0717L9.43564 18.5003L8.14992 14.2145L18.0071 6.92879L10.7214 15.0717Z",
    fill: "#56565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.054e3692c88eb9f38162b79b77abf233.svg";
export { ForwardRef as ReactComponent };